export default {
  cart: {
    preview: "/api/getCartItems",
    list: "/api/getCart",
    actions: "/local/ajax/basketAction.php",
    createDeal: "/local/ajax/orderAction.php",
    updateUnrecognized: "/local/ajax/updateNotRecognized.php",
    changeUnrecognizedItem: "/local/ajax/changeUnrecognizedItem.php",
    searchArticles: "/api/eparts/v2/searchHelper",
    removeAttachedFile: "/api/removeAttachedFile",
    updateUserPriceStatus: "/api/cart/user_price/is_active"
  },
  company: {
    list: "/api/companies",
    listByManager: "/local/ajax/route/crm/company/get_manager_company_list/",
    setActive: "/local/ajax/setActiveMyCustomer.php"
  },
  manager: {
    setActive: "/local/ajax/route/system/set_active_manager/"
  },
  wishlist: {
    list: "/api/wishlists",
    addList: "/local/ajax/wishlist/addWishList.php",
    removeList: "/local/ajax/wishlist/removeWishList.php",
    updateList: "/local/ajax/wishlist/updateWishList.php",
    addItem: "/local/ajax/wishlist/addItemToWishList.php",
    addBasket: "/local/ajax/wishlist/addBasketToWishlist.php",
    removeItem: "/local/ajax/wishlist/removeFormWishList.php",
    moveItemToList: "/local/ajax/wishlist/moveToWishList.php"
  },
  belts: {
    dataAfterFiltration: "/api/beltsArticles"
  },
  wearResistant: {
    initialData: "/api/wearResistantData",
    material: "/api/wearResistantMaterial",
    materialSpecification: "/api/wearResistantMaterialSpecification",
    materialReferences: "/api/wearResistantMaterialReferences",
    articles: "/api/wearResistantArticles",
    calculatorData: "/api/wearResistantCalculator"
  },
  orderHistory: {
    orders: "/api/orders",
    companiesByManager: "/api/orderHistoryCompanies",
    repeatOrder: "/api/repeatOrder",
    toggleHiddenOrder: "/api/toggleHiddenOrder",
  },
  orderDetail: {
    orderApprove: "/api/order/approve",
    orderDecline: "/api/order/decline",
    article: "/api/order/article",
    updateMarkupValue: "/api/order/markup/value/set",
    updateMarkupValues: "/api/order/markup/values/set",
    updateMarkupType: "/api/order/markup/type/set",
    updateMarkupStatus: "/api/order/markup/is_active",
    updateCommercialOfferStatus: "/api/order/commercialOffer/is_active",
    updateLeadTime: "/api/order/leadtime/value/set"
  },
  requests: {
    sendRequest: "/local/ajax/crm/addRequest.php",
    sendMessage: "/local/ajax/crm/addRequestComment.php",
    clearMessagesCounter: "/local/ajax/crm/hideMessageCounter.php"
  },
  newsletter: "/api/newsletter",
  bugreport: "/api/bugreport",
  breadcrumbs: "/api/breadcrumbs",
  mess: "/api/mess",
  millLining: {
    typesByCompany: "/api/millLining/typesByCompany",
    equipmentByCompanyAndType: "/api/millLining/equipmentByCompanyAndType",
    form: "/api/millLining/form"
  },
  wearParts: {
    getBrands: "/api/wearParts/crushers/brands",
    getSubtypes: "/api/wearParts/crushers/subtypes",
    getModels: "/api/wearParts/crushers/models",
    getMaterials: "/api/wearParts/crushers/materials",
    getArticles: "/api/wearParts/crushers/articles"
  },
  consumptionPlan: {
    item: "/api/crm/consumption_plan/item",
    items: "/api/crm/consumption_plan/items",
    uploadFile: "/api/crm/consumption_plan/items_file"
  },
  catalog: {
    articles: "/local/ajax/catalog/searchArticulesCP.php",
    rplArticlesForConsumptionPlan:
      "/local/ajax/route/catalog/find_articules/?page=cp_page",
    allEquipment: "/local/ajax/allEquipment.php"
  },
  productionSite: {
    add: "/local/ajax/crm/addProductionSite.php"
  },
  installedBase: {
    create: "/local/ajax/crm/addInstallBase.php",
    update: "/local/ajax/crm/editInstallBase.php",
    newModel: "/local/ajax/crm/addRequestOnEquipment.php"
  },
  customers: {
    list: "/local/ajax/crm/getCustomersForMap.php"
  }
};
